/*
 * Microsoft Clarity custom events. Observe-only: every listener is delegated on
 * document and never touches cart, subscription, or form logic. Calls are guarded
 * so nothing throws if Clarity is absent (ad blocker, consent, or not yet loaded).
 * window.clarity is a queueing stub once the app embed loads, so calls made before
 * the library finishes are queued rather than lost.
 */
(function () {
  'use strict';

  function fire(name) {
    if (typeof window.clarity !== 'function') return;
    try { window.clarity('event', name); } catch (e) {}
  }

  function tag(key, value) {
    if (typeof window.clarity !== 'function') return;
    try { window.clarity('set', key, value); } catch (e) {}
  }

  /* Clicks: add to cart, subscribe/one-time cards, guarantee link, blog cards. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* 1. Add to cart. Standard Shopify submit button (name="add"), which is the
       PDP main form and the homepage buy block. Dynamic checkout is not included. */
    if (t.closest('button[name="add"], .product-form__submit')) { fire('add_to_cart'); return; }

    /* 5. "Your One Jar Guarantee" link, PDP trust strip or footer. */
    if (t.closest('a[href*="/policies/refund-policy"]')) { fire('guarantee_click'); return; }

    /* 7. Article card on the /blogs/journal (Resources) index. The card is the link. */
    if (t.closest('a.journal-card')) { fire('blog_article_click'); return; }

    /* 2 and 3. Subscribe vs one-time card on the PDP selector. Clicks inside the
       frequency control are excluded, that is tracked as frequency_changed. */
    var opt = t.closest('.csel-opt');
    if (opt && !t.closest('.csel-freq')) {
      if (opt.classList.contains('csel-opt--featured')) fire('subscribe_selected');
      else fire('onetime_selected');
      return;
    }
  }, false);

  /* 4. Delivery frequency dropdown on the PDP, with the chosen label as a tag. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.id === 'csel-freq-select') {
      var opt = t.options && t.options[t.selectedIndex];
      if (opt) tag('delivery_frequency', (opt.textContent || '').trim());
      fire('frequency_changed');
    }
  }, false);

  /* 6. FAQ accordion open on the PDP. The toggle event does not bubble, so this
     listens in the capture phase. Fires only on open, and only for the PDP FAQ
     (.pfaq-item), not the homepage FAQ (.faq-item). */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('details.pfaq-item') && d.open) { fire('faq_open'); }
  }, true);
})();
